<template>
    <div class="tab-pane fade show active position-relative" id="activity">
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3 class="pt-2 mb-2">Scheduled Content Changes</h3>
                </div>
            </div>
            <scheduled-content-changes :product-id="productDetails.info.id + ''" class="pt-3"></scheduled-content-changes>
        </div>
    </div>
</template>

<script>
import ScheduledContentChanges from '../scheduled-content-changes/scheduled-content-changes.vue';

export default {
    name: 'product-scheduled-content',
    components: {
        'scheduled-content-changes': ScheduledContentChanges,
    },
    props: {
        productDetails: Object
    },
    data() {
        return {
            loading: false
        }
    },
    mounted() {},
    methods: {}
}
</script>

<style lang="scss" scoped>

</style>
